<template>
  <div class="collection-container">
    <div class="head-dec"></div>
    <div class="bookshelf box">
      <div class="part-title">&diams;<span class="inline-title">我的收藏</span></div>
      <div class="collection-grid">
        <div class="item" v-for="record in records" :key="record.id">
          <img class="cover" @click="goTo(record.sourceId)" :src="`${coverPrefix}/${record.sourceId.split('_')[0]}/${record.sourceId}/TIFF/0001.jpg`" />
          <div class="text">{{ record.sourceName }}</div>
        </div>
      </div>
      <div class="bottom-tools">
        <div class="icon first-page" @click="curPage = 1"></div>
            <div class="icon pre" @click="curPage -= 1"></div>
            <div class="pager"><el-input v-model="curPage" style="width: 70px"></el-input>&nbsp;/&nbsp;{{ pages }}</div>
            <div class="icon next" @click="curPage += 1"></div>
            <div class="icon last-page" @click="curPage = pages"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Custom from '@/api/custom'
import baseConfig from '@/config'
const api = new Custom('bookCollections')
export default {
  data () {
    return {
      coverPrefix: baseConfig.coverPrefix,
      curPage: 1,
      pageSize: 30,
      pages: 100,
      records: []
    }
  },
  methods: {
    getData () {
      api
        .getRecords({
          pageIndex: 1,
          pageSize: this.pageSize
        })
        .then(res => {
          this.records = res.rows
          this.pages = Math.ceil(res.count / this.pageSize)
        })
    },
    goTo (sourceId) {
      let url = window.location.origin + window.location.pathname
      window.open(`${url}#/book${this.$isPhone ? '-mobile' : ''}?sourceId=${sourceId}`)
    }
  },
  mounted () {
    this.pageSize = this.$isPhone ? 16 : 30
    this.getData()
  },
  watch: {
    curPage (val) {
      if (val < 1 || val > this.pages) return
      this.getClassList()
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";

@media screen and (min-width: 769px) {
  .collection-container {
  width: 1920px;
  background-image: url("~@/assets/images/page-bg.png");
  background-size: 1920px 1549px;
  font-family: "FangZhengKaiTi-GBK";
  .bookshelf {
    width: 1820px;
    height: 739px;
    margin: 10px 50px;
    .collection-grid {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .item {
        text-align: center;
        margin-left: 34px;
        margin-top: 8px;
        cursor: pointer;
        .cover {
          width: 140px;
          height: 170px;
        }
        .text {
          color: #7a7374;
        }
      }
    }
  }
  .bottom-tools {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
    color: #7c1823;
    .icon {
      width: 38px;
      height: 38px;
      background-size: 100% 100%;
      cursor: pointer;
      margin-left: 36px;
    }
    .pager {
      margin-left: 32px;
      display: flex;
      align-items: center;
      color: #7a7374;
      .font-size-medium;
      /deep/ .el-input__inner {
        text-align: center;
        .font-size-medium;
        background: #f5f2eb;
        height: 28px;
        line-height: 28px;
      }
      /deep/ .el-input__icon {
        color: #7a7374;
      }
    }
  }
}
}
@media screen and (max-width: 768px) {
  .collection-container {
  width: 1080px;
  background-image: url("~@/assets/images/page-bg.png");
  background-size: 1080px 1549px;
  font-family: "FangZhengKaiTi-GBK";
  .bookshelf {
    width: 1000px;
    height: 1530px;
    margin: 10px 50px;
    .collection-grid {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .item {
        text-align: center;
        margin-left: 34px;
        margin-top: 8px;
        cursor: pointer;
        .cover {
          width: 200px;
          height: 280px;
        }
        .text {
          color: #7a7374;
          font-size: 28px;
          max-width: 200px;
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .bottom-tools {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
    color: #7c1823;
    .icon {
      width: 64px;
      height: 64px;
      background-size: 100% 100%;
      cursor: pointer;
      margin-left: 36px;
    }
    .pager {
      margin-left: 32px;
      display: flex;
      align-items: center;
      color: #7a7374;
      font-size: 36px;
      /deep/ .el-input__inner {
        text-align: center;
        font-size: 36px;
        background: #f5f2eb;
        height: 48px;
        line-height: 48px;
      }
      /deep/ .el-input__icon {
        color: #7a7374;
      }
    }
  }
}
}
</style>
